import React from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Switch from "react-switch";
import { useTalentTeam } from '../../../providers/TalentTeamProvider';

import {useAuth} from "../../../providers/AuthProvider";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {Img} from "react-image";

const TalentTeamPanel = ({ isDisabled,...props }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const {auth} = useAuth()
    const {
        team,
        updateTeamDetails,
        isUpdating,
        acceptTeamInvite,
        rejectTeamInvite
    } = useTalentTeam();


    const teamDetailLink = team?.detailLink?.();

    if (!team) return null;

    return (
        <div className="bg-white w-full md:w-96">

            <div className="p-2 bg-[#C2CFE0] text-center">
                <p className="uppercase text-xs font-bold">
                    {team.can_manage ? (
                        team.is_owner ? 'Team Owner' : 'Team Admin'
                    ) : (
                        team.is_invite ? 'Invited to Join' : 'Team Member'
                    )}
                </p>
            </div>

            <div className="px-6 py-4 flex flex-col gap-2.5 text-center">

                <div>
                    {!team.is_invite ? (
                        <Link
                            className="text-lg font-bold"
                            to={teamDetailLink}
                        >
                            {team.name}
                        </Link>
                    ) : (
                        <p className="text-lg font-bold">
                            {team.name}
                        </p>
                    )}

                    <p className="text-xxs text-secondary font-base text-center mt-1">({team.positions_count}) Members</p>
                </div>


                <div className="h-[155px] -mx-2 self-stretch justify-center items-center flex flex-col">
                    <Img loader={<LoadingSpinner/>} className={TB.mapClass("img-fluid max-h-full", {
                        'img-grayscale': !team.banner_image_path
                    })}
                         src={[team.banner_image_path || '/images/heads.png']}/>
                </div>

                <div>
                    <p className="text-xxs font-semibold underline text-left mb-0">About</p>
                    <div className={TB.mapClass("team-panel-bio", {
                        "unstyled mb-1.5": !TB.stripHtml(team.bio)?.length
                    })} dangerouslySetInnerHTML={{__html: TB.stripHtml(team.bio)?.length > 0 ? team.bio : '<i>No Description</i>'}}/>
                </div>

                <div className={TB.mapClass("flex justify-center items-center gap-2", {
                    "pointer-events-none": team.is_invite
                })}>
                    <Switch
                        height={21}
                        width={42}
                        disabled={isDisabled || !!isUpdating}
                        checked={team.is_approved && team.is_available && team.approved_talent_service_groups_count > 0}
                        onChange={val => {
                            if (!team.can_manage) {
                                return TB.toast('Only the team admins can update team availability', {theme: 'danger'})
                            }
                            if (!team.is_approved) {
                                return TB.toast('Team availability cannot be set until approved for project types', {theme: 'danger'})
                            }

                            return updateTeamDetails({ is_available: !team.is_available })
                        }}
                        onColor={TB.config('color.light_purple')}
                        offColor={TB.config('color.disabled')}
                        uncheckedIcon={null}
                        checkedIcon={null}
                        activeBoxShadow={'0 0 0.5px 1px ' + TB.config('color.success-dark')}
                        className="react-switch"
                        id={`accepting-jobs-${team.id}`}
                    />

                    <label className="text-xxs font-bold tracking-widest uppercase" htmlFor={`accepting-jobs-${team.id}`}>
                        Accepting Jobs
                    </label>
                </div>
                <div className="h-[90px] flex flex-col justify-between gap-2 mt-2">

                    {team.is_invite ? (
                        <React.Fragment>
                            <button className="btn btn-success" disabled={isDisabled || isUpdating} onClick={() => acceptTeamInvite()}>
                                Accept Invite
                            </button>
                            <div className="border-t border-wripplePrimaryLightGray h-[1px] w-full"></div>
                            <button className="btn btn-dark" disabled={isDisabled || isUpdating} onClick={async() => {
                                let confirm = await TB.alert('alert', 'Decline Team Invitation', 'Are you sure you want to decline the team invitation?',[
                                    {title: 'Yes, Continue'},
                                    {title: 'Cancel'},
                                ])
                                if (confirm) {
                                    return rejectTeamInvite()
                                }
                            }}>
                                Decline Invite
                            </button>
                        </React.Fragment>
                    ): (
                        <React.Fragment>
                            {!team.is_invite && (
                                <Link to={teamDetailLink} disabled={isDisabled || isUpdating} className="btn btn-primary">
                                    {team.can_manage ? 'Manage' : 'View'}
                                </Link>
                            )}

                            <div className="border-t border-wripplePrimaryLightGray h-[1px] w-full"/>

                            <div>
                                {(team.is_approved && team.approved_talent_service_groups_count > 0) ? (!team.is_available ? (
                                    <p><i className="fas fa-times-circle text-danger mr-2" /> Approved/Inactive</p>
                                ) : (
                                    <p><i className="fas fa-check-circle text-success mr-2" /> Approved/Active</p>
                                )) : (
                                    <p><i className="fas fa-spinner mr-2" /> Pending Setup</p>
                                )}
                            </div>
                        </React.Fragment>
                    )}
                </div>

            </div>
        </div>
    );
}

export default TalentTeamPanel;